import React from "react";
import { MapPin, Navigation, Phone, CalendarCheck } from "lucide-react";
import { COMPANY, mapsEmbedUrl, mapsRouteUrl } from "@/lib/company";
import { ConsentMap } from "@/components/MapConsent";

export const LocationMap = ({ testId = "location-map" }) => (
  <div data-testid={testId} className="grid lg:grid-cols-5 rounded-2xl overflow-hidden border border-line bg-surface">
    <div className="lg:col-span-2 p-8 md:p-10 flex flex-col">
      <p className="eyebrow">Standort</p>
      <h3 className="font-display font-bold text-2xl md:text-3xl text-ink mt-5 uppercase tracking-tight">{COMPANY.legalName}</h3>
      <p className="flex items-start gap-3 text-dim mt-6 leading-relaxed" data-testid={`${testId}-address`}>
        <MapPin size={18} className="text-brand shrink-0 mt-1" />
        <span>{COMPANY.street}<br />{COMPANY.city}, {COMPANY.country}</span>
      </p>
      {COMPANY.appointmentOnly && (
        <p className="flex items-center gap-3 text-sm text-dim mt-4">
          <CalendarCheck size={16} className="text-brand shrink-0" /> Besichtigung nach Terminvereinbarung
        </p>
      )}
      <div className="flex flex-wrap gap-3 mt-8 lg:mt-auto lg:pt-10">
        <a href={mapsRouteUrl} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-route-btn`}
          className="btn-pill inline-flex items-center gap-2 bg-action text-action-ink hover:bg-action-hover px-6 py-3.5 text-sm font-semibold">
          <Navigation size={15} /> Route planen
        </a>
        <a href={COMPANY.phoneLink} data-testid={`${testId}-call-btn`}
          className="btn-pill inline-flex items-center gap-2 border border-line text-ink hover:border-silver px-6 py-3.5 text-sm font-semibold">
          <Phone size={15} /> Anrufen
        </a>
      </div>
    </div>
    <div className="lg:col-span-3 relative min-h-[360px] md:min-h-[420px] bg-elevated">
      <ConsentMap src={mapsEmbedUrl} title={`${COMPANY.legalName} – Standort ${COMPANY.city}`} testId={testId} />
    </div>
  </div>
);

export default LocationMap;
